import { useEffect, useRef, useState } from 'react'
import SendIcon from '../assets/sendIcon'

const splitStringAt = (index, xs) => [xs.slice(0, index), xs.slice(index)]

export default function Input({ send, sending: isSending, dataset, disabled = true, isExpanded}) {
    const [message, setMessage] = useState('')
    const { 
        send_icon_color
    } = dataset
    const input = useRef()
    const onKeyDown = e => {

        // Check if the event target is the widget input element
        const isInputElement = e.target.id === 'widget-freetext-entry';
        if (isInputElement && e.keyCode === 32) {
            // Manually controlling the caret position due to input being controlled
            const caret = e.target.selectionStart
            const element = e.target
            window.requestAnimationFrame(() => {
              element.selectionStart = caret + 1
              element.selectionEnd = caret + 1
            })
            // On Chrome + Firefox spacebar default behaviour results in scrolling.
            e.preventDefault();
            const newMessage = splitStringAt(caret, message)
            setMessage(`${newMessage[0]} ${newMessage[1]}`) // Append a space character to the message
        }
        if (e.key === 'Enter') {
            e.preventDefault()
            trySend()
        }
    }

    const trySend = () => {
        let msg = message.trim()
        const buttons = document.querySelector('#springbok_chatbot_widget')?.shadowRoot?.querySelectorAll('.responseButton') ?? document.querySelectorAll('.responseButton')
        for (let button of buttons) {

            button.parentElement.remove()
        }
        if (msg && !isSending) {
            send(msg)
            setMessage('')
        }
    }

    useEffect(() => {
        //if playing with user customisation using SettingsGUIWrapper, use if (!testing && input.current)
        if (input.current && !disabled) input.current.focus()
    }, [dataset])


    return (
        <div className={'userInput flexR ' + (isExpanded && 'fullScreen')}>
            <div className='inputArea flexR'>
            <textarea
                id='widget-freetext-entry'
                ref={input}
                value={message}
                onChange={e => setMessage(e.target.value)}
                onKeyDown={onKeyDown}
                placeholder="Write a message..."
            />
            <SendIcon stroke={send_icon_color} onClick={trySend} role='button' alt='sendButton' className='sendButton'/>
            </div>
        </div>
    )
}
